module.exports = __webpack_public_path__ + "aa54cfbaffb1c4308e599a1ca4707d55.svg";